import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {ApplicationConfig} from '@angular/core';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling} from '@angular/router';
import {appRoutes} from './app.routes';
import {BasicAuthInterceptor} from './mt-security/basic-auth-interceptor';
import {ErrorInterceptor} from './mt-security/error-interceptor';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {providePrimeNG} from 'primeng/config';
import {defaultPreset} from './app.theme';



export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled'
        }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        {provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        providePrimeNG({
            license: 'eyJpZCI6IjNjZGZiNWZmLWRkYjEtNDVlYS1iMmJjLWY5MzIwNGViNTk3MSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODc3NTU3ODAsImV4cCI6MTgxOTI5MTc4MH0.1lEL7_azlQr6V0m-hmv8wXUkNhgmYywh7-UxfJJWiDO-uBnECjRta4ZVAFuMIQWHE7Od-WlXWLKvxdQOV-LtCQ',
            theme: {preset: defaultPreset, options: {darkModeSelector: '.app-dark', color: 'blue'}}}),
        // TODO: replace with animate.enter or animate.leave https://angular.dev/guide/animations
        provideAnimationsAsync()
    ]
};
